/* eslint-disable import/prefer-default-export */
import { call } from 'redux-saga/effects';

import { rebootSystemRequest } from '../requests';

export function* rebootSystemService() {
  yield call(rebootSystemRequest);
}
